import { Form } from 'antd';
import { FC } from 'react';

import { Rule } from 'models/form';

type FormItemProps = {
	rules?: Rule[];
	name: string;
	children: JSX.Element;
	valuePropName?: string;
	className?: string;
	type?: string;
	validateTrigger?: string;
	normalize?: (v: string) => any;
	value?: string;
};

export const FormItem: FC<FormItemProps> = ({
	rules,
	name,
	children,
	valuePropName,
	className,
	validateTrigger,
	normalize,
}) => {
	return (
		<Form.Item
			id={name}
			validateTrigger={validateTrigger}
			className={className}
			rules={rules}
			name={name}
			valuePropName={valuePropName}
			normalize={normalize}
		>
			{children}
		</Form.Item>
	);
};
